// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI, {Message} from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios/lib/axios'

ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.config.productionTip = false
Vue.use(ElementUI)

// var BasePath = 'https://192.168.0.140:5003/'//测试版本
// var BasePath = 'http://192.168.0.140:8991/'//测试版本
// var BasePath = 'http://192.168.0.127:897/'
// var BasePath = 'http://101.204.227.175:897/'
// var BasePath = 'https://101.204.227.175:900/'
var BasePath = 'https://www.guyuanct.com:900/'
axios.defaults.baseURL = BasePath + 'api/'
// axios.interceptors.request.use((config) => {
//     // config.headers.Authorization = "Bearer " + window.sessionStorage.getItem('token');
//     // config.headers.Power = window.sessionStorage.getItem('Power');
//     // config.headers.OperProjectid = window.sessionStorage.getItem('OperProjectid');
//     return config;
// })


//axios拦截器

axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.data.check == false) {
            return Promise.reject(response.data.msgText)
        } else if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    }
);


Vue.prototype.$http = axios
Vue.prototype.BasePath = BasePath;

//加载提示信息
Vue.prototype.openLoading = function (text = "数据加载中...") {
    const loading = this.$loading({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    return loading;
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js